export default __webpack_public_path__ + "static/media/damacicons.143ff548.ttf";